import Base from '@studiometa/js-toolkit';
import transition from '@studiometa/js-toolkit/utils/css/transition';
import { isDev } from '../config';

/**
 * LangSwitcher class
 */
export default class LangSwitcher extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'LangSwitcher',
      log: isDev(),
      styles: {
        el: {
          closed: 'opacity-0 pointer-events-none',
          active: 'transition duration-700 ease-out-expo',
        },
      },
    };
  }

  /**
   * Getter Is Open ?
   */
  get isOpen() {
    return this.$refs.list.classList.contains('is-open');
  }

  /**
   * Mounted
   */
  mounted() {
    // eslint-disable-next-line prefer-destructuring
    this.menuBurger = this.$parent.$children.Header[0].$children.MenuBurger[0];

    if (!this.menuBurger) {
      return;
    }

    this.menuBurger.$on('open', this.display);
    this.menuBurger.$on('close', this.hide);

    this.links = this.$refs.item.map((item) => {
      const element = item.querySelector('a');
      const isActive = item.classList.contains('is-active');
      if (isActive && element) {
        element.addEventListener('click', this.toggleOpen);
      }

      return {
        parent: item,
        isActive,
        element,
      };
    });
  }

  /**
   * Destroyed
   */
  destroyed() {
    this.menuBurger.$off('open', this.display);
    this.menuBurger.$off('close', this.hide);

    this.hide();

    if (this.isOpen) {
      this.toggleOpen();
    }

    this.links
      .filter((link) => link.isActive)
      .forEach((link) => {
        link.removeEventListener('click', this.toggle);
      });
  }

  /**
   * Toggle
   * @param {Event} event Click event
   */
  toggleOpen(event) {
    if (event) {
      event.preventDefault();
    }

    this.$refs.list.classList.toggle('is-open');

    this.links
      .filter((link) => !link.isActive)
      .forEach((link, index) => {
        link.parent.style.transform = this.isOpen ? `translateY(${100 * (index + 1)}%)` : '';
      });
  }

  /**
   * Display
   */
  display() {
    this.$el.classList.remove('hidden');

    return transition(this.$el, {
      from: this.$options.styles.el.closed,
      active: this.$options.styles.el.active,
    });
  }

  /**
   * Hide
   */
  hide() {
    if (this.isOpen) {
      this.toggleOpen();
    }

    return transition(
      this.$el,
      {
        active: this.$options.styles.el.active,
        to: this.$options.styles.el.closed,
      },
      'keep'
    ).then(() => {
      this.$el.classList.add('hidden');
    });
  }
}
